export const LocalStorageKeys = {
    hideDone: 'hideDone',
    jamesLanguage: 'jamesLanguage',
    cookCategories: 'cookCategories',
    barmenFilter: 'barmenFilter',
    restaurantInfoTab: 'restaurantInfoTab',
    restaurantToCopy: 'restaurantToCopy',
    userData: 'userData',
    expandedSection: (sectionId: string) => `expanded-${sectionId}`,
    navGroupView: 'navGroupView',
    navSelectedGroup: 'navSelectedGroup',
    reservationsPinnedDay: (restaurantId: string) => `reservationsPinnedDay-${restaurantId}`,
} as const;
